var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"api-key-created-date-table-cell"},[_c('div',{staticClass:"api-key-created-date-table-cell__date"},[_vm._v(" "+_vm._s(_vm.formattedDate)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }